export default __webpack_public_path__ + "static/form-grouping-do-1e802a5c94cc4a9d131e7a0e5eb0828cdb6d7826c378a713e3e69d2272ed7f78.png";